(() => {
  'use strict';
  if (window.OeoPhotoStudioLoaded) return;
  window.OeoPhotoStudioLoaded = true;
  const examples = {
    coast: 'https://cdn.shopify.com/s/files/1/0980/1950/files/oeo-upload-photo-example-coast.jpg?v=1789466664',
    mountains: 'https://cdn.shopify.com/s/files/1/0980/1950/files/oeo-upload-photo-example-mountains.jpg?v=1789466673',
    dog: 'https://cdn.shopify.com/s/files/1/0980/1950/files/oeo-upload-photo-example-dog.jpg?v=1789466681'
  };
  const init = () => {
    const root = document.querySelector('[data-photo-studio]');
    if (!root || root.dataset.ready) return;
    const host = root.closest('product-info');
    const input = host?.querySelector('input[type="file"][name="properties[Photo]"]');
    const form = input?.form;
    if (!input || !form) return;
    root.dataset.ready = 'true';
    const q = s => root.querySelector(s);
    const canvas = q('[data-studio-canvas]'), ctx = canvas.getContext('2d');
    const frame = q('[data-studio-frame]'), paper = q('[data-studio-paper]');
    const orientation = form.querySelector('[name="properties[Image Orientation]"]');
    const style = form.querySelector('[name="properties[Photo Style]"]');
    const zoom = q('[data-studio-zoom]'), panX = q('[data-studio-x]'), panY = q('[data-studio-y]');
    let selected = JSON.parse(host.querySelector('[data-selected-variant]')?.textContent || 'null');
    let image = null, sample = false, objectURL = null, crop = null, loadId = 0, fileValid = false;
    if (!orientation.value) orientation.value = 'Portrait';
    if (!style.value) style.value = 'Original colour';
    const status = text => { q('[data-studio-status]').textContent = text; };
    input.accept = 'image/jpeg,image/png,image/webp,image/heic,image/heif,.jpg,.jpeg,.png,.webp,.heic,.heif';
    const help = document.createElement('p');
    help.className = 'photo-upload-help';
    help.textContent = 'Original JPG, PNG, WebP or HEIC · up to 20 MB. HEIC preview depends on your browser.';
    input.after(help);
    const size = () => {
      const label = selected?.option1 || selected?.options?.[0] || 'A4';
      let dims;
      if (/^A4\b/.test(label)) dims = [21,29.7];
      else if (/^A3\b/.test(label)) dims = [29.7,42];
      else if (/^A2\b/.test(label)) dims = [42,59.4];
      else { const m=label.match(/(\d+)\s*x\s*(\d+)\s*cm/i); dims=m?[+m[1],+m[2]]:[21,29.7]; }
      dims.sort((a,b)=>a-b);
      return orientation.value==='Landscape' ? [dims[1],dims[0]] : dims;
    };
    const reset = () => { zoom.value='1';panX.value='50';panY.value='50'; };
    const render = () => {
      const [w,h]=size(), ratio=w/h;
      const maxW=Math.max(120,q('[data-studio-wall]').clientWidth-100), maxH=q('[data-studio-wall]').clientHeight-112;
      let fw=Math.min(maxW,maxH*ratio),fh=fw/ratio;
      frame.style.width=`${fw}px`;frame.style.height=`${fh}px`;
      frame.dataset.finish=selected?.option2 || selected?.options?.[1] || 'Oak';
      const border=selected?.option3 || selected?.options?.[2] || 'With White Border';
      paper.dataset.border=border.startsWith('No Border')?'none':'white';
      q('[data-studio-dimension]').textContent=`${w} × ${h} cm · ${orientation.value} · ${frame.dataset.finish.replace(' Art Print','')}`;
      // A single pixel inset keeps the white margin equal on every edge.
      const borderFraction=paper.dataset.border==='white'?.08:0;
      const margin=Math.min(fw,fh)*borderFraction;
      paper.style.setProperty('--studio-border',`${margin}px`);
      const imageRatio=(fw-2*margin)/(fh-2*margin);
      canvas.width=Math.round(imageRatio>=1?1200:1200*imageRatio);canvas.height=Math.round(imageRatio>=1?1200/imageRatio:1200);
      q('[data-studio-zoom-output]').textContent=`${Number(zoom.value).toFixed(2).replace(/0$/,'').replace(/\.0$/,'')}×`;
      if (!image) return;
      const iw=image.naturalWidth,ih=image.naturalHeight,z=+zoom.value;
      const baseW=Math.min(iw,ih*imageRatio),baseH=baseW/imageRatio;
      const cw=baseW/z,ch=baseH/z,x=(iw-cw)*Number(panX.value)/100,y=(ih-ch)*Number(panY.value)/100;
      ctx.fillStyle='#ffffff';ctx.fillRect(0,0,canvas.width,canvas.height);
      ctx.filter=style.value==='Black & white'?'grayscale(1)':style.value==='Sepia'?'sepia(1)':'none';
      ctx.drawImage(image,x,y,cw,ch,0,0,canvas.width,canvas.height);ctx.filter='none';
      crop={version:1,x:Math.round(x),y:Math.round(y),width:Math.round(cw),height:Math.round(ch),originalWidth:iw,originalHeight:ih,orientation:orientation.value,style:style.value,previewBorderFraction:borderFraction};
      root.dataset.crop=JSON.stringify(crop);
      const physicalMargin=Math.min(w,h)*borderFraction;
      const dpi=Math.floor(Math.min(cw/((w-2*physicalMargin)/2.54),ch/((h-2*physicalMargin)/2.54)));
      q('[data-studio-quality]').textContent=sample?'Example photo only. Upload your own original before ordering.':`${iw} × ${ih} px · Approx. ${dpi} ppi at this size and crop. ${dpi>=200?'Good detail for this print size.':dpi>=100?'May look softer close up. Consider a smaller size for finer detail.':'Low resolution at this size. Try a smaller print or a higher-resolution original.'} Our team checks the original before printing.`;
    };
    const showImage = (img,isSample) => {
      image=img;sample=isSample;reset();
      canvas.hidden=false;q('[data-studio-empty]').hidden=true;q('[data-studio-editor]').hidden=false;
      q('[data-studio-badge]').textContent=isSample?'Example photo':'Your photo preview';
      q('[data-studio-caption]').textContent=isSample?'An example, not your upload.':'Your image. Styled exactly your way.';
      render();
    };
    q('[data-studio-upload]').addEventListener('click',()=>input.click());
    input.addEventListener('change',async()=>{
      const file=input.files[0],current=++loadId;
      image=null;crop=null;fileValid=false;sample=false;delete root.dataset.crop;
      canvas.hidden=true;q('[data-studio-empty]').hidden=false;q('[data-studio-editor]').hidden=true;
      root.querySelectorAll('[data-example]').forEach(b=>b.setAttribute('aria-pressed','false'));
      input.setCustomValidity('');status('');
      if (!file) {render();return;}
      if (file.size>20*1024*1024 || !/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name)) {
        const msg=file.size>20*1024*1024?'Choose an image under 20 MB.':'Choose a JPG, PNG, WebP or HEIC image.';
        input.setCustomValidity(msg);status(msg);input.reportValidity();render();return;
      }
      if(objectURL)URL.revokeObjectURL(objectURL);
      objectURL=URL.createObjectURL(file);
      const img=new Image();img.src=objectURL;
      try {
        await img.decode();if(current!==loadId)return;
        if(img.naturalWidth*img.naturalHeight>100000000)throw new Error('Image exceeds 100 megapixels. Please use a smaller copy.');
        fileValid=true;orientation.value=img.naturalWidth>=img.naturalHeight?'Landscape':'Portrait';
        orientation.dispatchEvent(new Event('change',{bubbles:true}));
        showImage(img,false);q('[data-studio-upload]').firstChild.textContent='Change photo ';
        help.textContent=`${file.name} · Original selected. Your crop and preview will be saved with this item.`;
      } catch(err) {
        if(current!==loadId)return;
        if(/\.hei[cf]$/i.test(file.name)) {
          fileValid=true;help.textContent=`${file.name} · Original selected. This browser cannot preview HEIC. Upload a JPG for a crop preview, or order the original for our team to check.`;
          status('HEIC original selected. No crop or preview will be applied.');
        } else {input.setCustomValidity('This image could not be opened. Choose another JPG or PNG.');status(input.validationMessage);}
      }
    });
    root.querySelectorAll('[data-example]').forEach(button=>button.addEventListener('click',async()=>{
      if(input.files.length){status('Your photo is selected. To protect your edits, examples are available before uploading.');return;}
      const current=++loadId;status('');
      try {
        const img=new Image();img.crossOrigin='anonymous';img.src=examples[button.dataset.example];await img.decode();if(current!==loadId)return;
        orientation.value=img.naturalWidth>=img.naturalHeight?'Landscape':'Portrait';
        root.querySelectorAll('[data-example]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        showImage(img,true);
      } catch(_) {status('The example could not load. You can still upload your own photo.');}
    }));
    [orientation,style].forEach(el=>el.addEventListener('change',render));
    [zoom,panX,panY].forEach(el=>el.addEventListener('input',render));
    q('[data-studio-reset]').addEventListener('click',()=>{reset();render();});
    document.addEventListener('variant:changed',e=>{const v=e.detail?.variant;if(v&&host.querySelector('[name=id]')?.value===String(v.id)){selected=v;render();}});
    new ResizeObserver(()=>render()).observe(q('[data-studio-wall]'));
    form.addEventListener('formdata',event=>{
      const data=event.formData;
      if(image && !sample && fileValid && input.files.length && crop) {
        data.set('properties[_Crop specification]',JSON.stringify(crop));
        const binary=atob(canvas.toDataURL('image/jpeg',.92).split(',')[1]);
        const bytes=Uint8Array.from(binary,c=>c.charCodeAt(0));
        data.set('properties[Composition preview]',new File([bytes],'your-photo-composition.jpg',{type:'image/jpeg'}));
        data.set('properties[_Preview note]','Composition reference only. Print from the original Photo using Crop specification. Border follows selected variant.');
      }
    });
    // Required inputs still own validation; examples never become orderable uploads.
    form.addEventListener('submit',event=>{
      if(!input.files.length || !fileValid || !form.checkValidity()){
        event.preventDefault();event.stopImmediatePropagation();form.reportValidity();
        if(!input.files.length){status('Upload your own photo before adding to cart.');input.focus();}
      }
    },true);
    render();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
